import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class PitchShift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.effect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Pitch'
                        parameter={this.state.effect.pitchParameter}
                        sequencerEngine={this.props.sequencerEngine}
                        selectedParameter={this.props.selectedParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.01}
                        max={24}
                        min={-24}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Window Size'
                        parameter={this.state.effect.windowSizeParameter}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        selectedParameter={this.props.selectedParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.01}
                        max={0.2}
                        min={0.03}
                        />
                      <WetSlider
                            effectNumber={this.props.effectNumber}
                            sequencerEngine={this.props.sequencerEngine}
                            automation={this.props.automation}
                            selectedParameter={this.props.selectedParameter}
                            onParameterChanged={this.props.onParameterChanged}
                            effect={this.state.effect}/>
                 </div>} 
            </div>
        );
    }
}

export default PitchShift;
